// This file is here because Netlify dev needs a page present at "/"
const PageNull = () => null;
export default PageNull;
